import SmallSetPagination from "../pagination/SmallSetPagination";
import CommissionsCardHorizontal from "./CommissionsCardHorizontal";

function CommissionsList({ commissions, get_commissions_page, count }) {
  return (
    <div className="overflow-hidden bg-white">
      <div className="relative overflow-x-auto">
        <table className="table text-gray-500">
          <thead className="text-xs text-gray-700 uppercase">
            <tr>
              <th scope="col" className="p-2">
                Rol
              </th>
							<th scope="col" className="p-2">
                Nivel
              </th>
							<th scope="col" className="p-2">
                Compensacion
              </th>

							<th scope="col" className="p-2">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {commissions &&
							commissions.map((commission, index) => (
								<CommissionsCardHorizontal
									data={commission}
									key={index}
									index={index}
								/>
							))}
          </tbody>
        </table>
      </div>
      <SmallSetPagination
        list_page={get_commissions_page}
				list={commissions}
				count={count}
      />
    </div>
  );
}

export default CommissionsList;
